import React from "react";
import * as Bananas from "bananas-commerce-admin";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

export interface DeleteConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteConfirmationDialog: React.FC<
  DeleteConfirmationDialogProps
> = ({ open, onClose, onConfirm }) => {
  const { t } = Bananas.useI18n();

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      PaperProps={{
        sx: {
          borderRadius: 8,
        },
      }}
      onClose={onClose}
    >
      <DialogTitle sx={{ pt: 4, pb: 2 }}>
        <Typography fontSize={24}>{t("Bekräfta borttagning")}</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack gap={1}>
          <Typography color="text.secondary" variant="body2">
            {t(
              "Är du säker på att du vill ta bort detta utgivningsschema? Detta kan inte ångras.",
            )}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose}>{t("Avbryt")}</Button>
        <Button color="error" variant="text" onClick={onConfirm}>
          {t("Ta bort")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
